import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { needCommaInText } from '../../../../helpers/needCommaInText';
import { dashboardActions } from '../../../../../../store/slices/dashboardSlice/dashboardSlice';

export const useMainInformation = () => {
    const dispatch = useDispatch();
    const { information, is_customer, can_show_financial_info } = useSelector(
        //@ts-ignore
        (state) => state.dashboardReducer
    );
    const [values, setValues] = useState([]);
    const [needBlur, setNeedBlur] = useState(false);

    const onClickAddInfo = () => {
        dispatch(dashboardActions.onModalMode('editInformation'));
    };
    useEffect(() => {
        const setInformationValues = () => {
            setValues([
                {
                    title: i18next.t(
                        'useMainInformation.return.setInformationValues.informationName'
                    ),
                    text: information.name ? information.name : null,
                },
                {
                    title: i18next.t(
                        'useMainInformation.return.setInformationValues.informationAddress'
                    ),
                    text: information.address ? information.address : null,
                },
                {
                    title: i18next.t(
                        'useMainInformation.return.setInformationValues.informationContract'
                    ),
                    text:
                        information.contract_number || information.contract_date
                            ? needCommaInText(
                                  information.contract_number,
                                  information.contract_date
                              )
                            : null,
                },
                {
                    title: i18next.t(
                        'useMainInformation.return.setInformationValues.informationDescription'
                    ),
                    text: information.description ? information.description : null,
                },
            ]);
        };
        setInformationValues();
        setNeedBlur(
            information.address === '' &&
                information.contract_date === '' &&
                information.contract_number === '' &&
                information.description === ''
        );
    }, [
        information.name,
        information.address,
        information.description,
        information.contract_number,
        information.contract_date,
    ]);

    return { values, needBlur, is_customer, onClickAddInfo, can_show_financial_info };
};
